<template>
    <div class="bg-white shadow-md mb-64 rounded mx-auto relative p-48 max-w-640">
        <div class="mb-32 min-h-[30rem] w-480 mx-auto">
            <lottie-animation
                :animationData="animation"
                :autoPlay="true"
                :loop="true"
                :speed="1"
            />
        </div>

        <popup-content :description="$t('free_trial.lets_go')"
                       :show-progress-bar="false"
                       :title="$t('free_trial.welcome')"
        ></popup-content>

        <div class="mt-48 flex justify-center space-x-20">
            <simple-button class="uppercase w-200"
                           display="secondary"
                           look="primary"
                           @click="$emit('next')">
                {{ $t('free_trial.start') }}
            </simple-button>
        </div>
    </div>
</template>

<script>
import SimpleButton from '../SimpleButton.vue';
import PopupContent from './PopupContent.vue';
import {LottieAnimation} from "lottie-web-vue";
import animation from '../../../../../../../public/interim/animations/welcome.json';

export default {
    name: 'Welcome',
    components: {PopupContent, SimpleButton, LottieAnimation},
    data() {
        return {
            choice: null,
            animation
        };
    },
};
</script>
